import type { ButtonHTMLAttributes } from 'react';
import { PrototypeIcon } from './PrototypeIcon';
/** Croix commune à toutes les pop-ins ; la fermeture et ses gardes appartiennent
 * toujours au dialogue (saisie, opération en cours, retour du focus). */
export function ModalCloseButton(
  props: Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'type'>,
): React.JSX.Element {
  return (
    <button
      {...props}
      type="button"
      className={'tosho-modal-close ' + (props.className ?? '')}
      aria-label={props['aria-label'] ?? 'Fermer'}
      title={props.title ?? 'Fermer'}
    >
      <PrototypeIcon name="x" />
    </button>
  );
}
